import React from "react";

export default (props) => {
	return (
		<div className="banner">
			<header className="header-banner">
				<div className="banner-content"></div>
			</header>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/js/common/components/layouts/Banner.js